var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rightLayoutWrap1"},[_c('div',{staticClass:"height100pScrollWrap"},[(_vm.edocPop.modesTaskData)?_c('imageCall',{attrs:{"modesTaskData":_vm.edocPop.modesTaskData}}):_c('div',[_vm._v("加载中...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }